var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['notification-stack']},[_c('GlobalNotifications'),_c('NotificationToasts',{attrs:{"toasts":_vm.toasts,"duration":_vm.duration},on:{"close":_vm.removeToast,"action":_vm.emitAction,"success":_vm.emitAction,"delete":_vm.emitAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }